module.exports = {

    // 测试
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://supergeng.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normalgeng.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normalgeng.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'h5': 'https://h5.v3.geng.jiuzhouapi.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
    //     // 'service_tag': 'LOCAL',
    //     'city_tag': 'ONLINE_MAIN' //分城市
    // }


    // 耿师傅线上环境
    config: {
        'localStorage_token_name': 'access_token',
        'axios_timeout': 20000, // 请求超时时间20秒
        'axios_baseURL': 'https://super.gsfdj.com',
        'axios_normalURL': 'https://normal.gsfdj.com',
        'axios_imgURL': 'https://normal.gsfdj.com/qiniu/upload',
        'hash_key': 'gcss9csffhhc9z',
        'h5': 'https://h5.gsfdj.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
        //   // 'service_tag': 'LOCAL',
        'city_tag': 'ONLINE_MAIN' //分城市
    }
}


// WEBPACK FOOTER //
// ./src/utils/config.js